import { render, staticRenderFns } from "./supplier-detail.vue?vue&type=template&id=3828f93e&scoped=true&"
import script from "./supplier-detail.vue?vue&type=script&lang=js&"
export * from "./supplier-detail.vue?vue&type=script&lang=js&"
import style0 from "./supplier-detail.vue?vue&type=style&index=0&id=3828f93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828f93e",
  null
  
)

export default component.exports